module.exports = function () {

    var typeaheadHelper = require('./../../helpers/typeahead-helper.js');

	function generateNewItemFields(index, today, duplicated) {

		if(typeof duplicated !== 'undefined'){
			var date = duplicated.date,
				creditor = duplicated.creditor,
				propertyId = duplicated.propertyId,
				propertyName = duplicated.propertyName,
				ticketId = duplicated.ticketId;
		} else{
			var date = '',
				creditor = '',
				propertyId = '',
				propertyName = '',
				ticketId = '';
		}

		var newFieldGroup =
			'<div class="expense-to-add property-by-ticket">' +

            '<div class="row">' +
            '<div class="col-sm-4"><button class="btn btn-expense btn-remove" type="button">Delete</button><button class="btn btn-expense btn-duplicate" type="button" data-index="' + index + '">Duplicate</button></div>' +
            '</div>' +

            '<div class="row">' +
            '<div class="col-sm-4"><div class="form-group"><label for="expenses[' + index + '][ticket_id]" class="control-label col-sm-5">Ticket Id</label><div class="col-sm-7"><input class="js-ticket-id-field-typeahead typeahead form-control" name="expenses[' + index + '][ticket_id]" type="text" id="expenses[' + index + '][ticket_id]" value="'+ ticketId +'" </div></div></div></div>' +
            '<div class="col-sm-4"><div class="form-group"><label for="expenses[' + index +'][property_name]" class="control-label col-sm-3">Property</label><div class="col-sm-9"><div class="input-image"><input class="js-property-field-typeahead typeahead form-control" name="expenses[' + index +'][property_name]" type="text" id="expenses[' + index +'][property_name]" value="'+ propertyName +'"><input class="js-property-id-field" id="expenses[' + index +'][property_id]" name="expenses[' + index +'][property_id]" type="hidden" value="'+ propertyId +'"></div></div></div></div>'+
            '<div class="col-sm-4"><div class="form-group"><label for="expenses[' + index +'][type_id]" class="control-label col-sm-4">Type</label><div class="col-sm-8"><select class="form-control" name="expenses[' + index +'][type_id]" id="expenses[' + index +'][type_id]"></select></div></div><div class="clearfix"></div></div>'+
            '</div>' +

            '<div class="row">' +
            '<div class="col-sm-4"><div class="form-group "><label for="expenses[' + index + '][purchase_order_number]" class="control-label col-sm-5">Purchase Order</label><div class="col-sm-7"> <input class="form-control" name="expenses[' + index + '][purchase_order_number]" type="text" id="expenses[' + index + '][purchase_order_number]"></div></div></div>' +
            '<div class="col-sm-4"><div class="form-group "><label for="expenses[' + index + '][invoice_number]" class="control-label col-sm-5 label-required">Invoice number</label><div class="col-sm-7"><input class="form-control" required="required" name="expenses[' + index + '][invoice_number]" type="text" id="expenses[' + index + '][invoice_number]"></div></div></div>' +
            '<div class="col-sm-4"><div class="form-group "><label for="expenses[' + index + '][creditor]" class="control-label col-sm-4 label-required">Company</label><div class="col-sm-8"><input class="form-control" required="required" name="expenses[' + index + '][creditor]" type="text" id="expenses[' + index + '][creditor]" value="'+ creditor +'"></div></div></div>' +
            '</div>' +

            '<div class="row">'+
            '<div class="col-sm-4"><div class="form-group "><label for="expenses[' + index + '][due_date]" class="control-label col-sm-5 label-required">Due Date</label><div class="col-sm-7"><input class="form-control js-datepicker" required="required" name="expenses[' + index + '][due_date]" type="text" id="expenses[' + index + '][due_date]" value="'+ date +'"></div></div></div>' +
            '<div class="col-sm-4"><div class="form-group "><label for="expenses[' + index + '][amount]" class="control-label col-sm-6 label-required">Amount Due</label><div class="col-sm-6"> <input class="form-control" required="required" name="expenses[' + index + '][amount]" type="text" id="expenses[' + index + '][amount]"> </div></div></div>' +
            '<div class="col-sm-4"><div class="form-group"><label for="expenses[' + index + '][file]" class="control-label col-sm-3">File</label><div class="col-sm-9"><div class="input-image"><input class="form-control" name="expenses[' + index + '][file]" type="file" id="expenses[' + index + '][file]"></div></div></div><div class="clearfix"></div></div>' +
            '</div>' +

            '</div>';

		return newFieldGroup;
	}

    jQuery.fn.extend({
        reloadTypeahead : function () {
            typeaheadHelper.typeaheadInitProperty(typeaheadHelper.engineProperty);
            typeaheadHelper.typeaheadInitTicketId(typeaheadHelper.engineTicketsId);
        }
	});

	$(document).on('generateNewItem', function(e) {
        let context = e.target;

        $('generateNewItem', context).reloadTypeahead();
    });

	$(document).ready(function () {

		var moment = require('moment');

		var today = moment( new Date() ).format('DD/MM/YYYY');
		$(this).trigger('generateNewItem');
		$('.js-property-field-typeahead-initialized').trigger('change');

        $(document).on('click', '.js-datepicker', function (e) {

            $(this).datepicker({
                autoclose: true,
                format: "dd/mm/yyyy"
            });


        }).on('click', '.btn-remove', function (e) {

            $(this).parents('.row:first').parents('.expense-to-add').remove();

            e.preventDefault();
            return false;

        }).on('click', '.btn-add-new', function (e) {

	        var $wrapper = $('#add-many-expenses-wrapper'),
                globalIndex = $wrapper.data('index');

	        var newFieldGroup = generateNewItemFields(++globalIndex, today);

	        var controlForm = $('.controls');

	        $(newFieldGroup).appendTo(controlForm).trigger('generateNewItem');

            var valueZero = '<option value="">Please Select</option>';

            $('select[name="expenses[' + globalIndex +'][type_id]"]').prepend(valueZero);
            $('select[name="expenses[0][type_id]"] optgroup').clone().appendTo('select[name="expenses[' + globalIndex +'][type_id]"]');

	        $wrapper.data('index', globalIndex);

        }).on('click', '.btn-duplicate', function (e) {

            var $this = $(this),
                index = $this.data('index'),
                $wrapper = $('#add-many-expenses-wrapper'),
                globalIndex = $wrapper.data('index'),
                copiedDate = $('input[name="expenses[' + index + '][due_date]"]').val(),
                copiedCreditor = $('input[name="expenses[' + index + '][creditor]"]').val(),
                copiedPropertyName = $('input[name="expenses[' + index + '][property_name]"]').val(),
                copiedPropertyId = $('input[name="expenses[' + index + '][property_id]"]').val(),
                copiedTicketId = $('input[name="expenses[' + index + '][ticket_id]"]').val(),
                copiedTypes = $('select[name="expenses[' + index + '][type_id]"]').val();

            var duplicated = {
                    date : copiedDate,
                    creditor : copiedCreditor,
                    propertyName : copiedPropertyName,
                    propertyId : copiedPropertyId,
                    ticketId : copiedTicketId,
                };

	        var newFieldGroup = generateNewItemFields(++globalIndex, today, duplicated);

	        var controlForm = $('.controls');

	        $(newFieldGroup).appendTo(controlForm).trigger('generateNewItem');

            $('select[name="expenses[' + index + '][type_id]"] optgroup').clone().appendTo('select[name="expenses[' + globalIndex +'][type_id]"]');
            $('select[name="expenses[' + globalIndex +'][type_id]"]').val(copiedTypes);

	        $wrapper.data('index', globalIndex);

        });
    });
}();
